<h5>
  <i class="fa fa-users me-2"></i>{{ 'screening.monitoring_connection.title' | translate }}
  <nk-help-popover [popoverTemplate]="tipPopoverTemplate"></nk-help-popover>
</h5>

@if (data$ | async; as data) {
  <nk-card-list
    [cardListConfig]="cardListConfig"
    [data]="data"
    [isLoading]="isLoading()"
    [collapsibleDetails]="collapsibleDetails()"></nk-card-list>
}
@if (error(); as error) {
  <nk-error-alert [error]="error"></nk-error-alert>
}
<ng-template #tipPopoverTemplate>
  <h5>{{ 'screening.monitoring_connection.tip.title' | translate }}</h5>
  <div [innerHTML]="'screening.monitoring_connection.tip.message' | translate"></div>
</ng-template>
